import type { IMaskFunction } from 'interfaces/IMask';

const onlylettersandspace: IMaskFunction = {
  apply: (value: string) => {
    if (!value) return '';
    return value.replace(/[^a-zA-Z ]/g, '').toUpperCase();
  },
  clean: (value: string) => value.replace(/\d/gi, ''),
};

export default onlylettersandspace;
